export const AUTH_TOKEN_NAME = 'auth_token'

const getToken = () => localStorage.getItem(AUTH_TOKEN_NAME) || undefined

const setToken = (token: string) => localStorage.setItem(AUTH_TOKEN_NAME, token)

const removeToken = () => localStorage.removeItem(AUTH_TOKEN_NAME)

const hasToken = () => !!getToken()

export const authToken = { getToken, setToken, removeToken, hasToken }
